export default __webpack_public_path__ + "static/media/sowpay.8a1a7e12.ico";